module.exports = __webpack_public_path__ + "static/nishant-14f1926ff4287583db9733115ed25ae2.jpeg";